import {ghostButton, GhostButton} from "./button/GhostButtonComponent";
import {ghostContainer, GhostContainer} from "./container/GhostContainerComponent";
import {ghostImage, GhostImage} from "./image/GhostImageComponent";
import {ghostText, GhostText} from "./text/GhostTextComponent";

export default function() {
    return angular.module("tfApp.components.ui.ghost", [])
                  .component(GhostButton, ghostButton())
                  .component(GhostContainer, ghostContainer())
                  .component(GhostImage, ghostImage())
                  .component(GhostText, ghostText())
                  .name;
}
